import BaseTransformer from "./base.transformer"
import PlanPriceTransformer from "./planPrice.transformer"
export const baseUri = "/api/plans"

const publicPlans = ["free", "lite", "essential"]
const planToKeyMap = {
  free: "free",
  lite: "pro1",
  essential: "pro2",
  growth: "growth",
  custom: "custom",
  large: "large"
}

const demoPlans = ["large", "demo"]

function sortPrices(prices) {
  return prices
    .sort((a, b) => (a.months > b.months ? 1 : b.months > a.months ? -1 : 0))
    .sort()
    .reverse()
}

class PlanTransformer extends BaseTransformer {
  static fetch(plan) {
    const uuid = this.transformUuid(plan)
    const planName = plan.name ?? plan.displayName
    let planTransformed = this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      name: planName ? planName.toLowerCase() : null,
      nameInCapitalLetters: `${plan.displayName.charAt(0).toUpperCase()}${plan.displayName.slice(1)}`,
      features: plan.features || {},
      level: plan.level,
      displayName: plan.displayName,
      isPublic: publicPlans.includes(plan.displayName),
      isPremium: plan.isPremium,
      isActive: plan.isActive,
      isDemo: demoPlans.includes(plan.displayName.toLowerCase()),
      translationKey: planToKeyMap[plan.displayName],
      prices:
        plan.prices && plan.prices?.length
          ? sortPrices(
              plan.prices?.map((price) =>
                typeof price === "string" ? price : PlanPriceTransformer.fetch(price)
              )
            )
          : []
    })

    planTransformed["priceMonthly"] =
      planTransformed.prices.find((price) => price.months === 1) || {}

    planTransformed["priceYearly"] =
      planTransformed.prices.find((price) => price.months === 12) || {}

    return planTransformed
  }
}

export default PlanTransformer
